import React from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';
import Image from 'next/image';

import { IResolvedESimCompatible } from '@/src/utils/collections/eSim-compatible.mapper';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@/src/components/ui/dialog';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/src/components/ui/accordion';

interface IProps {
  eSimCompatible?: IResolvedESimCompatible;
}

export const DestinationDetailsESimCompatible = ({
  eSimCompatible,
}: IProps) => {
  return (
    <>
      {eSimCompatible && (
        <Dialog>
          <DialogTrigger>
            <div
              className={
                'flex items-center gap-1 rounded-lg bg-neutral-100 p-3 hover:bg-neutral-200 active:bg-neutral-300'
              }
            >
              <p className={'flex items-center font-semibold text-gray'}>
                {eSimCompatible.textButton}
              </p>
              <Image
                src={'/static/icons/chevron-down.svg'}
                alt=""
                width={10}
                className={'ml-2 mt-1'}
                height={7}
              />
            </div>
          </DialogTrigger>
          <DialogContent
            className={
              'no-scrollbar flex size-full max-h-full min-h-[300px] flex-col overflow-y-scroll p-0 md:size-auto'
            }
          >
            <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none  disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
              <Cross2Icon className="size-8" />
              <span className="sr-only">Close</span>
            </DialogClose>
            <div className={'mx-8 mt-10 text-3xl font-bold'}>
              {eSimCompatible.popup.title}
            </div>
            <div className={'h-auto px-8 pt-4 text-3xl font-semibold'}>
              <Accordion
                type="single"
                collapsible
                className="mb-4 flex w-[500px] max-w-full flex-col gap-4"
              >
                {eSimCompatible.popup.items.map((item, i) => (
                  <AccordionItem
                    key={`eSimCompatible-popup-${i}`}
                    value={`eSimCompatible-popup-${i}`}
                    className={'rounded-2xl border-0'}
                  >
                    <AccordionTrigger
                      className={
                        'overflow-hidden rounded-2xl bg-black px-8 text-lg text-white hover:no-underline'
                      }
                    >
                      {item.sectionTitle}
                    </AccordionTrigger>
                    <AccordionContent
                      className={'bg-white px-8 py-4 text-black'}
                    >
                      {item.sectionContent}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
            <div className={'px-8'}>{eSimCompatible.popup.additionalText}</div>
            {eSimCompatible.textButton && (
              <DialogClose
                className={
                  'mx-8 mb-8 rounded-4xl bg-primary p-4 text-lg font-bold text-white hover:bg-primary/90 active:bg-primary-dark'
                }
              >
                {eSimCompatible.popup.button}
              </DialogClose>
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
